import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { userId: String }

  connect() {
    this.apply()
    this.observer = new MutationObserver(() => this.apply())
    this.observer.observe(this.element, { childList: true })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  apply() {
    this.element.querySelectorAll("[data-author-id]").forEach((bubble) => {
      if (bubble.classList.contains("nw-messenger__bubble--system")) return

      const mine = bubble.dataset.authorId === this.userIdValue
      bubble.classList.toggle("nw-messenger__bubble--sent", mine)
      bubble.classList.toggle("nw-messenger__bubble--received", !mine)
    })
  }
}
